// import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Loading from 'components/UI/Loading/Loading';
import MemoriesCarousel from 'components/UI/MemoriesCarousel/MemoriesCarousel';

import classes from './AllMemoriesContainer.module.css';

// let isInitial = true;

const AllMemoriesContainer = props => {
  // const [loading, setLoading] = useState(true);
  // const [initialMemory, setInitialMemory] = useState(0);
  // const [newMemories, setNewMemories] = useState([]);
  // console.log(
  //   '🚀 ~ AllMemoriesContainer ~ newMemories:',
  //   newMemories
  // );

  // useEffect(() => {
  //   let memoriesData = [];
  //   let start = 0;
  //   let indexMemory = 0;
  //   props.memories.map((memory, index) => {
  //     if (props.memoryView === memory.memoryId) {
  //       indexMemory = index - 5;
  //       if (indexMemory <= 0) {
  //         indexMemory = 0;
  //       }
  //     }
  //   });
  //   props.memories.map((memory, index) => {
  //     if (indexMemory === index && start < 10) {
  //       memoriesData.push(memory);
  //       indexMemory = index + 1;
  //       start = start + 1;
  //     }
  //   });
  //   setNewMemories(memoriesData);
  // }, []);

  // useEffect(() => {
  //   if (newMemories.length > 0) {
  //     if (isInitial === true) {
  //       newMemories.map((memory, index) => {
  //         if (props.memoryView === memory.memoryId) {
  //           setInitialMemory(index);
  //         }
  //       });
  //       newMemories;
  //       isInitial = false;
  //       setTimeout(() => {
  //         setLoading(false);
  //       }, 1000);
  //     }
  //   }
  // }, [newMemories]);

  // const loadMoreMemoriesHandler = indexMemory => {
  //   let memoryId = 0;
  //   if (indexMemory === 8) {
  //     // const newMemory = {
  //     //   userTributId: null,
  //     //   memoryId: 904,
  //     //   userId: '1665172652829',
  //     //   url: 'https://d3cohyhv4rpctw.cloudfront.net/Logo_Tribut.png',
  //     //   urlOrigin:
  //     //     'https://memoriam-multimedia.s3.amazonaws.com/73/memory/904/1717538043571.PNG',
  //     //   thumbnail:
  //     //     'https://d3cohyhv4rpctw.cloudfront.net/Logo_Tribut.png',
  //     //   message: '',
  //     //   likes: 0,
  //     //   mediaType: 'jpeg',
  //     //   published: '04/06/2024',
  //     //   timePublished: 1717538043,
  //     //   avatar:
  //     //     'https://d3sx6i1tuxnqjw.cloudfront.net/1665172652829/avatar/1673478197841.jpeg',
  //     //   firstName: 'Manuel',
  //     //   lastName: 'Tamez',
  //     //   durationInMs: null,
  //     //   widthInPx: null,
  //     //   heightInPx: null,
  //     //   isOwnerTribut: false,
  //     //   isOwnerMemory: false,
  //     //   comments: [],
  //     //   countLikes: 0,
  //     //   isOwnerLike: false
  //     // };
  //     // let newData = newMemories;

  //     // newData.splice(0, 1);
  //     // newData.push(newMemory);

  //     // console.log(
  //     //   '🚀 ~ loadMoreMemoriesHandler ~ newData:',
  //     //   newData
  //     // );

  //     // setNewMemories(newData);
  //     newMemories.map((newMemory, index) => {
  //       if (indexMemory === index) {
  //         memoryId = newMemory.memoryId;
  //         console.log('🚀 ~ newMemories.map ~ memoryId:', memoryId);
  //         let memoriesData = [];
  //         let start = 0;
  //         let indexMemory = 0;
  //         props.memories.map((memory, index) => {
  //           if (memoryId === memory.memoryId) {
  //             indexMemory = index - 5;
  //             if (indexMemory <= 0) {
  //               indexMemory = 0;
  //             }
  //           }
  //         });
  //         props.memories.map((memory, index) => {
  //           if (indexMemory === index && start < 10) {
  //             memoriesData.push(memory);
  //             indexMemory = index + 1;
  //             start = start + 1;
  //           }
  //         });
  //         // memoriesData.map((memory, index) => {
  //         //   if (memoryId === memory.memoryId) {
  //         //     setInitialMemory(index);
  //         //   }
  //         // });
  //         setLoading(true);
  //         setTimeout(() => {
  //           setLoading(false);
  //         }, 1);
  //         setNewMemories(memoriesData);
  //       }
  //     });
  //   }

  //   if (indexMemory === 1) {
  //     newMemories.map((memory, index) => {
  //       if (indexMemory === index) {
  //         console.log('memory', memory);
  //       }
  //     });
  //   }
  // };

  const handleBack = () => {
    if (typeof props.changeView === 'function') {
      props.changeView('all');
    }
  };

  return (
    <section className={classes.memoriesContainer} id="allMemories">
      <div className={classes.allMemoriesContainer}>
        <div className={classes.headerContainer}>
          <Button
            component={Link}
            to={`/tribut/${props.tributId}/memorias`}
            onClick={handleBack}
            className={classes.btnBack}
            aria-label="Regresar a memorias"
          >
            <ArrowBackIcon className={classes.btnBackIcon} />
          </Button>
          <p className={classes.title}>Memorias</p>
        </div>
        <MemoriesCarousel
          memories={props.memories}
          tributId={props.tributId}
          memoryView={props.memoryView}
          onDeleteMemory={props.onDeleteMemory}
          changeView={props.changeView}
          loadData={props.loadData}
        />
      </div>
    </section>
  );
};

AllMemoriesContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  tributId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  // eslint-disable-next-line react/require-default-props
  memories: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  memoryView: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  className: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  style: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  onClick: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  onDeleteMemory: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  loadData: PropTypes.func
};

export default AllMemoriesContainer;
